import { render, staticRenderFns } from "./ReportTabBusinessTerm.vue?vue&type=template&id=4242ddb6&scoped=true&lang=pug"
import script from "./ReportTabBusinessTerm.vue?vue&type=script&lang=js"
export * from "./ReportTabBusinessTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4242ddb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4242ddb6')) {
      api.createRecord('4242ddb6', component.options)
    } else {
      api.reload('4242ddb6', component.options)
    }
    module.hot.accept("./ReportTabBusinessTerm.vue?vue&type=template&id=4242ddb6&scoped=true&lang=pug", function () {
      api.rerender('4242ddb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/report/ReportTabBusinessTerm.vue"
export default component.exports